module.exports = __webpack_public_path__ + "static/media/Air-pollution-very-high.81b1e9ff.svg";